export const mciTempDocTypes = {
  registration: 'mciRegistration',
}
